import React, { useState } from 'react'
import SingleBudgetElements from './SingleBudgetElements';

function EditBudgetElementArray({elements, setElements}) {

    const [description, setDescription] = useState("");
    const [value, setValue] = useState(0);

    function addElement() {
        const newEl = [{
            description: description,
            sum: value,
            elId: new Date().getTime()
        }]
        console.log(newEl)

        let newElementsArray

        if (elements) {
            newElementsArray = elements.concat(newEl);
        } else {
            newElementsArray = newEl;
        }
         
        console.log(newElementsArray)
        
        setElements(newElementsArray);

    }

    return (
        <div className="my-4">

            <h4>Budsjettelementer</h4>

            <SingleBudgetElements mode="edit" elements={elements} setElements={setElements} />

            <label>Beskrivelse utgift / inntekt</label>
            <input type="text" className="form-control mb-2" value={description} onChange={e => setDescription(e.target.value)} />

            <label>Utgift / Inntekt sum</label>
            <input type="number" className="form-control mb-2" value={value} onChange={e => setValue(e.target.value)}  />
            <div style={{cursor: "pointer"}} className="btn btn-primary btn-block" onClick={addElement}>Legg til element</div>
        </div>
    )

} 
export default EditBudgetElementArray